import {
  AlertCircleIcon,
  ArrowDown01Icon,
  ArrowLeft01Icon,
  ArrowRight01Icon,
  ArrowUp01Icon,
  BadgeCheckIcon,
  BriefcaseBusinessIcon,
  Cancel01Icon,
  CenterFocusIcon,
  CheckmarkCircle02Icon,
  Copy01Icon,
  Delete02Icon,
  Download01Icon,
  DragDropVerticalIcon,
  Edit02Icon,
  EnergyIcon,
  File01Icon,
  FileExportIcon,
  Flag01Icon,
  GitGraphIcon,
  GraduationCapIcon,
  GridViewIcon,
  HierarchyIcon,
  InformationCircleIcon,
  BulbIcon,
  JobSearchIcon,
  ListViewIcon,
  Loading03Icon,
  LockIcon,
  Mail01Icon,
  MailSend01Icon,
  Megaphone01Icon,
  Mic01Icon,
  MinusSignIcon,
  PlayIcon,
  PlusSignIcon,
  RefreshIcon,
  SearchIcon,
  SparklesIcon,
  StarIcon,
  Tick02Icon,
  Unlink01Icon,
  Upload01Icon,
  UserCircleIcon,
  HeartIcon,
} from '@hugeicons/core-free-icons';
import { HugeIcon, type HugeIconData, type HugeIconProps } from './HugeIcon';
import { ShareIcon } from './ShareIcon';

const SYMBOLS: Record<string, HugeIconData> = {
  add: PlusSignIcon,
  remove: MinusSignIcon,
  close: Cancel01Icon,
  check: Tick02Icon,
  check_circle: CheckmarkCircle02Icon,
  verified: BadgeCheckIcon,
  error: AlertCircleIcon,
  info: InformationCircleIcon,
  lock: LockIcon,
  search: SearchIcon,
  progress_activity: Loading03Icon,
  upload: Upload01Icon,
  download: Download01Icon,
  content_copy: Copy01Icon,
  edit: Edit02Icon,
  edit_note: Edit02Icon,
  output: FileExportIcon,
  delete: Delete02Icon,
  refresh: RefreshIcon,
  play_arrow: PlayIcon,
  arrow_back: ArrowLeft01Icon,
  arrow_forward: ArrowRight01Icon,
  arrow_upward: ArrowUp01Icon,
  arrow_downward: ArrowDown01Icon,
  expand_more: ArrowDown01Icon,
  chevron_right: ArrowRight01Icon,
  drag_indicator: DragDropVerticalIcon,
  auto_awesome: SparklesIcon,
  sparkle: SparklesIcon,
  description: File01Icon,
  doc: File01Icon,
  mail: Mail01Icon,
  send: MailSend01Icon,
  grad: GraduationCapIcon,
  school: GraduationCapIcon,
  briefcase: BriefcaseBusinessIcon,
  work: JobSearchIcon,
  lightbulb: BulbIcon,
  person: UserCircleIcon,
  bolt: EnergyIcon,
  grid_view: GridViewIcon,
  record_voice_over: Mic01Icon,
  campaign: Megaphone01Icon,
  favorite: HeartIcon,
  star: StarIcon,
  flag: Flag01Icon,
  hub: HierarchyIcon,
  graph_1: GitGraphIcon,
  list: ListViewIcon,
  center_focus_strong: CenterFocusIcon,
  link_off: Unlink01Icon,
  unlink: Unlink01Icon,
};

export type HugeSymbolProps = Omit<HugeIconProps, 'icon'> & { name: string };

/**
 * Hugeicons-backed compatibility layer for legacy semantic symbol names.
 * Share names intentionally retain the canonical original share glyph.
 */
export function HugeSymbol({ name, spin, ...props }: HugeSymbolProps) {
  if (name === 'share' || name === 'ios_share') {
    return (
      <ShareIcon
        size={props.size}
        color={props.color ?? 'currentColor'}
        strokeWidth={props.strokeWidth}
        accessibilityElementsHidden={props.decorative ?? true}
        accessibilityLabel={props.accessibilityLabel}
      />
    );
  }
  return (
    <HugeIcon
      icon={SYMBOLS[name] ?? SparklesIcon}
      spin={spin ?? name === 'progress_activity'}
      {...props}
    />
  );
}
